import request from "@/utils/request";

export const getApps = () => request.get("/apps");

export const getApp = (id) => request.get(`/apps/${id}`);

export const createApp = (data) => request.post("/apps", data);

export const updateApp = (id, data) => request.put(`/apps/${id}`, data);

export const deleteApp = (id) => request.delete(`/apps/${id}`);

export const getPromoLinks = (appId) => request.get(`/apps/${appId}/promo-links`);
